import { render, staticRenderFns } from "./ServicePriceEdit.vue?vue&type=template&id=650dac16"
import script from "./ServicePriceEdit.vue?vue&type=script&lang=js"
export * from "./ServicePriceEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports